import { useState, useImperativeHandle, forwardRef, useRef, React } from 'react';
import styled from 'styled-components';

const NoteInput = forwardRef((props, ref) => {
	const { className, placeholder, type, disabled } = props;
	const [value, setValue] = useState('');
	const [changed, setChanged] = useState(false);
	const [clickCount, setClickCount] = useState(0);
	const [defaultPlaceholder, setDefaultPlaceholder] = useState(placeholder);

	const inputRef = useRef();

	useImperativeHandle(ref, () => ({
		setValue: (val) => {
			setValue(val);
			setChanged(true);
		},
		getValue: () => {
			if (changed)
				return value;
			else
				return "";
		},
		plusClickCount: () => {
			setClickCount(clickCount + 1)
		},
		getClickCount: () => {
			return clickCount;
		},
		invalidValue: () => {
			inputRef.current.style.borderColor = '#FF3131';
		},
		reset: (val) => {
			setClickCount(0);
			setDefaultPlaceholder(val)
			inputRef.current.style.borderColor = '#E8E8E8';
		}
	}));

	function handleClick(e) {
		inputRef.current.style.borderColor = '#FF8B48';
	}

	function handleChange(e) {
		setValue(e.target.value);
		setChanged(true);
	}

	function handleFocus(e) {
		if (changed) {
			// do nothing
		} else {
			setValue("");
		}
	}

	function handleBlur(e) {
		setClickCount(clickCount + 1);
		inputRef.current.style.borderColor = '#E8E8E8';
		if (value === "") {
			// setDefaultPlaceholder(placeholder);
			// inputRef.current.style.borderColor = '#FF3131';
		} 
		else {
			// inputRef.current.style.borderColor = '#E8E8E8';
		}
	}

	return (
		<Input
			ref={inputRef}
			clickCount={clickCount}
			type={type}
			placeholder={defaultPlaceholder}
			value={value || ''}
			disabled={disabled}
			className={`${className} ${changed ? "changed" : ""}`}
			onClick={handleClick}
			onChange={handleChange}
			onFocus={handleFocus}
			onBlur={handleBlur} />
		)
});

export default NoteInput;

const Input = styled.textarea`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

	width: max(618px, 80.46875vw);
	height: 69px;

	padding: 6px 8px 6px 8px;
	margin-top: 8px;

	outline: none;
	border: 1px solid #DFDFDF;
	border-radius: 8px;
	color: #000000;
  background-color: ${props => props.disabled ? '#ECECEC' : '#FFFFFF'};

	::placeholder {
		color: #CBCBCB;
	}
	
  transition: all 0.3s ease-in-out;
`;